module.exports = {
      id: "business-usage",
      viewBox: "0 0 28.79 24.369",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#business",
      toString: function () {
        return this.url;
      }
    }